<template>
  <div class="admin">
    <v-layout row wrap fill-height class="team admin__route">
      <v-flex xs12 md3>
        <v-card>
          <v-list class="py-0" expand v-if="$vuetify.breakpoint.mdAndUp">
            <category-item
              :parentRoute="parentRoute"
              v-for="category in categories"
              :key="category.id"
              :category="category"
            ></category-item>
          </v-list>

          <v-list v-else class="py-0">
            <v-list-group :value="listOpen" @click="listOpen = !listOpen">
              <v-list-tile slot="activator" class="decision-tree__category">
                <v-list-tile-content>
                  <v-list-tile-title>Choose a Category</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                v-for="category in categories"
                :key="category.id"
                ripple
                @click="listOpen = false"
                :to="`${parentRoute}/${category.url_slug}`"
                exact
              >
                <v-list-tile-content>{{category.name}}</v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 md9>
        <div class="document-center">
          <v-toolbar
            color="primary"
            dark
            dense
            class="admin__toolbar mb-3 pr-0"
            v-if="currentCategory"
          >
            <v-toolbar-title>Category: {{ currentCategory.name }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
              <v-btn
                flat
                class="mx-0"
                style="min-width: auto;"
                :input-value="grid"
                @click="grid = true"
              >
                <fa-icon icon="th-large"></fa-icon>
              </v-btn>
              <v-btn
                flat
                class="mx-0"
                style="min-width: auto;"
                :input-value="!grid"
                @click="grid = false"
              >
                <fa-icon icon="list"></fa-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <router-view :grid="grid" :key="$route.fullPath"></router-view>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CategoryItem from "./CategoryItem";

export default {
  name: "DocumentCenter",

  data() {
    return {
      listOpen: false,
      categories: [],
      grid: true,
      parentRoute: "/document-center"
    };
  },

  props: {
    slug: {
      default: ""
    }
  },

  components: {
    CategoryItem
  },

  computed: {
    ...mapGetters(["user"]),
    ...mapGetters("document_center", ["loadedCategory"]),

    currentCategory() {
      return this.loadedCategory(this.slug);
    }
  },

  methods: {
    ...mapActions("document_center", ["getCategories"]),
    ...mapMutations("document_center", ["setCategories"])
  },

  created() {
    this.getCategories({ topLevel: true }).then(({ data }) => {
      this.$set(this, "categories", data);
    });
  }
};
</script>
